module.exports = __webpack_public_path__ + "static/media/black_time_written.ce567b24.svg";